import { useStore } from 'effector-react';
import { routes } from 'features/verify/routes';
import { $route } from 'libs/router';
import { css } from 'linaria';
import { styled } from 'linaria/react';
import { MountType } from 'model/domain';
import { mountType$ } from 'model/main.model';
import { h, Fragment, FunctionalComponent } from 'preact';
import { localizationOptions$, openLocalizationPopup } from 'model/localization.model';

import { Footer } from 'ui/footer';
import { Container } from 'ui/container';
import { Button } from 'ui/atoms/button';
import { GlobeIcon } from 'ui/icons/globe-icon';
import { Header } from 'features/verify/ui/header';
import { Title, Subtitle, Text } from 'ui/typography';

type OnboardLayoutProps = {
	title: string;
	subtitle: string;
	info: Array<{ icon: any, text: any }>;
};

export const OnboardLayout: FunctionalComponent<OnboardLayoutProps> = (props) => {
	const { title, subtitle, info, children } = props;
	const route = useStore($route);
	const mountType = useStore(mountType$);
	const options = useStore(localizationOptions$);

	return (
		<Fragment>
			<Header
				extra={
					route === routes.welcome &&
					mountType === MountType.verification &&
					options.languageSelector && (
						<Button
							name={'open_language_popup'}
							onClick={() => openLocalizationPopup()}
							type={'default'}
							style={{ paddingLeft: 0 }}
						>
							<GlobeIcon
								fill={'var(--text-secondary)'}
							/>
						</Button>
					)
				}
			/>
			<Container style={{ paddingBottom: 10 }}>
				<Title
					className={titleClass}
				>
					{title}
				</Title>
				<Subtitle
					className={subtitleClass}
				>
					{subtitle}
				</Subtitle>
				{info.map(item => (
					<Text className={textClass}>
						<IconContainer>
							{item.icon}
						</IconContainer>
						<span>
							{item.text}
						</span>
					</Text>
				))}
				{children}
			</Container>
			<Footer/>
		</Fragment>
	);
};

const titleClass = css`
  margin-bottom: 8px;
`;
const subtitleClass = css`
  margin-bottom: 32px;
`;
const textClass = css`
  display: flex;
  margin-bottom: 16px;
`;
const IconContainer = styled('div')`
  display: flex;
  align-items: center;
  height: 22px;
  min-width: 18px;
  margin-right: 8px;

  svg {
    display: flex;
  }
`;
